module.exports = __webpack_public_path__ + "img/stock3.1de3c344.png";